import { useState, useEffect, useContext } from "react";
import Accordion from '@mui/material/Accordion';
import { styled } from "@mui/material/styles";
import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import AccordionDetails from '@mui/material/AccordionDetails';
import { Checkbox } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import plusReport from "../../../assets/svg/plusReport.svg";
import ReportContext,{ Types } from "../../../context/ReportsContext/ReportContext";
// @ts-ignore: allow importing CSS files without type declarations
import "../css/TreeView.css";

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ExpandMoreIcon />} {...props} />
))(() => ({ flexDirection: "row-reverse" }));

const TreeView = ({ columnas, camposPivotes }: any) => {
  const { state, dispatch } = useContext(ReportContext);
  const [checkedColumns, setCheckedColumns] = useState<string[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<string | null>(null);
  
  useEffect(() => {
    setCheckedColumns(state.reportPreviewData?.columnasVisibles || columnas || []);
    setSelectedGroup(state.reportPreviewData?.agrupadorSeleccionado || null);
  }, [columnas, state.reportPreviewData]);

  const handleToggleColumn = (col: string) => {
    const updated = checkedColumns.includes(col)
      ? checkedColumns.filter(c => c !== col)
      : [...checkedColumns, col];
    setCheckedColumns(updated);
    dispatch({ type: Types.UPDATE_VISIBLE_COLUMNS, payload: updated });
  };

  const handleSelectGroup = (campo: string) => {
    const newGroup = selectedGroup === campo ? null : campo;
    setSelectedGroup(newGroup);
    dispatch({ type: Types.UPDATE_SELECTED_GROUP, payload: newGroup });
  };

  return (
    <div className="selectoresReport">
      {/* Columnas */}
      <Accordion>
        <AccordionSummary style={{ borderBottom: '1px solid rgba(0,0,0,0.12)' }}>
          <div className="containerInfo">
            <div className="txtInfo">Campos de Columnas</div>
            <div><img src={plusReport} alt="add" /></div>
          </div>
        </AccordionSummary>
        <AccordionDetails style={{ padding: 0 }}>
          {columnas?.map((col: string, i: number) => (
            <div key={i} className="conteinerCampo">
              <div>{col}</div>
              <Checkbox
                checked={checkedColumns.includes(col)}
                onChange={() => handleToggleColumn(col)}
                sx={{ color: "#FABB00", "&.Mui-checked": { color: "#FABB00" } }}
              />
            </div>
          ))}
        </AccordionDetails>
      </Accordion>

      {/* Agrupador */}
      <Accordion>
        <AccordionSummary style={{ borderBottom: '1px solid rgba(0,0,0,0.12)' }}>
          <div className="containerInfo">
            <div className="txtInfo">Agrupador</div>
            <div><img src={plusReport} alt="add" /></div>
          </div>
        </AccordionSummary>
        <AccordionDetails style={{ padding: 0 }}>
          {camposPivotes?.map((campo: string, i: number) => (
            <div key={i} className="conteinerCampo">
              <div>{campo}</div>
              <Checkbox
                checked={selectedGroup === campo}
                onChange={() => handleSelectGroup(campo)}
                sx={{ color: "#FABB00", "&.Mui-checked": { color: "#FABB00" } }}
              />
            </div>
          ))}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default TreeView;
